/**
 * @description Barra de navegação mobile para o modo interno
 * @module MobileBarNavigation
 * @since Fevereiro 2024
 */

import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Assignment, Share, House, History } from "@mui/icons-material";
import { currentFeatures } from "@/configs/Settings";
import FluxVetLogo from "../../../../../assets/fluxvet-logo.png";
import FluxmedLogo from "../../../../../assets/fluxmed-logo.png";

const MobileBarNavigation: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();

  const navMenuItems = [
    {
      path: "/home",
      label: "Início",
      icon: House,
    },
    {
      path: "/myrecords",
      label: "Registros",
      icon: Assignment,
    },
    {
      path: "/consent",
      label: "Consentimento",
      icon: Share,
    },
  ];

  const vetMenuItems = [
    {
      path: "/home",
      label: "Início",
      icon: House,
    },
    {
      path: "/history",
      label: "Histórico de acessos",
      icon: History,
    },
  ];

  const getMenuItems = () => {
    const baseItems = currentFeatures?.defaultApp ? navMenuItems : vetMenuItems;
    if (window.ReactNativeWebView) {
      const webViewItem = currentFeatures?.defaultApp
        ? {
            path: "/fluxvet",
            label: "Fluxvet",
            icon: () => (
              <img
                src={FluxVetLogo}
                alt="Fluxvet Logo"
                style={{ width: 24, height: 24 }}
              />
            ),
          }
        : {
            path: "/fluxmed",
            label: "Fluxmed",
            icon: () => (
              <img
                src={FluxmedLogo}
                alt="Fluxmed Logo"
                style={{ width: 24, height: 24 }}
              />
            ),
          };
      return [...baseItems, webViewItem];
    }
    return baseItems;
  };

  const menuItems = getMenuItems();

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "block", md: "none" },
        zIndex: theme.zIndex.drawer + 2,
      }}
      elevation={3}
    >
      <BottomNavigation
        value={pathname}
        showLabels
        onChange={(_, newValue) => {
          if (newValue === "/fluxvet" || newValue === "/fluxmed") {
            if (window.ReactNativeWebView) {
              const message = currentFeatures?.defaultApp
                ? "Change Fluxvet"
                : "Change Fluxmed";
              window.ReactNativeWebView.postMessage(message);
            }
          } else {
            navigate(newValue);
          }
        }}
        sx={{
          bgcolor: "#FFFFFF",
          "& .Mui-selected": {
            color: "#00A884",
          },
        }}
      >
        {menuItems?.map((item) => {
          const Icon = item.icon;
          return (
            <BottomNavigationAction
              key={item.path}
              label={item.label}
              value={item.path}
              icon={Icon ? <Icon /> : null}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export { MobileBarNavigation };
